export const dailyQuizTranslations = {
  fr: {
    title: "Quiz quotidien",
    widgetTitle: "Quiz Quotidien",
    loading: "Génération de votre quiz personnalisé...",
    back: "Retour",
    home: "Accueil",
    unavailableTitle: "Quiz quotidien indisponible",
    unavailableDesc: "Impossible de générer le quiz pour aujourd'hui.",
    retry: "Réessayer",
    finished: "Quiz terminé",
    finishedExclaim: "Quiz terminé !",
    xpGained: "XP gagnés",
    daysStreak: "Jours consécutifs",
    timeSpent: "Temps passé",
    recentBadges: "Badges récents",
    backToDashboard: "Retour au tableau de bord",
    reviewWithFlashcards: "Réviser avec les flashcards",
    missingQuestionTitle: "Question manquante",
    missingQuestionDesc: "Une erreur s'est produite lors du chargement de la question.",
    reload: "Recharger",
    question: "Question",
    of: "/",
    explanation: "Explication",
    source: "Source",
    elapsed: "Temps écoulé",
    validate: "Valider",
    next: "Suivant",
    finish: "Terminer",
    today: "Aujourd'hui",
    difficulty: {
      easy: "facile",
      medium: "moyen",
      hard: "difficile"
    },
    widget: {
      currentStreak: "Série actuelle",
      thisWeek: "Cette semaine",
      xpThisWeek: "XP cette semaine:",
      startToday: "Commencer le quiz d'aujourd'hui",
      completedToday: "Quiz du jour terminé ✓",
      viewResults: "Voir les résultats"
    },
    weeklyChallenge: {
      title: "Défi hebdomadaire",
      progress: "Progression",
      done: "Défi complété !"
    },
    toasts: {
      loadError: "Impossible de charger le quiz quotidien",
      finishSuccess: (xp:number) => `Quiz terminé ! +${xp} XP`,
      saveError: "Erreur lors de la sauvegarde",
      offlineMode: "Quiz généré en mode hors-ligne"
    },
    celebrationSubtitle: "Vous avez obtenu {{percentage}}% au Quiz du jour",
    shareScore: "Partager mon score",
    successRate: "{{percentage}}% de réussite"
  },
  en: {
    title: "Daily Quiz",
    widgetTitle: "Daily Quiz",
    loading: "Generating your personalized quiz...",
    back: "Back",
    home: "Home",
    unavailableTitle: "Daily quiz unavailable",
    unavailableDesc: "Unable to generate today's quiz.",
    retry: "Retry",
    finished: "Quiz completed",
    finishedExclaim: "Quiz completed!",
    xpGained: "XP gained",
    daysStreak: "Days streak",
    timeSpent: "Time spent",
    recentBadges: "Recent badges",
    backToDashboard: "Back to dashboard",
    reviewWithFlashcards: "Review with flashcards",
    missingQuestionTitle: "Missing question",
    missingQuestionDesc: "An error occurred while loading the question.",
    reload: "Reload",
    question: "Question",
    of: "/",
    explanation: "Explanation",
    source: "Source",
    elapsed: "Elapsed time",
    validate: "Validate",
    next: "Next",
    finish: "Finish",
    today: "Today",
    difficulty: {
      easy: "easy",
      medium: "medium",
      hard: "hard"
    },
    widget: {
      currentStreak: "Current streak",
      thisWeek: "This week",
      xpThisWeek: "XP this week:",
      startToday: "Start today's quiz",
      completedToday: "Today's quiz completed ✓",
      viewResults: "View results"
    },
    weeklyChallenge: {
      title: "Weekly challenge",
      progress: "Progress",
      done: "Challenge completed!"
    },
    toasts: {
      loadError: "Unable to load daily quiz",
      finishSuccess: (xp:number) => `Quiz completed! +${xp} XP`,
      saveError: "Error while saving",
      offlineMode: "Quiz generated in offline mode"
    },
    celebrationSubtitle: "You scored {{percentage}}% on the Daily Quiz",
    shareScore: "Share my score",
    successRate: "{{percentage}}% success rate"
  },
  es: {
    title: "Quiz diario",
    widgetTitle: "Quiz diario",
    loading: "Generando tu quiz personalizado...",
    back: "Volver",
    home: "Inicio",
    unavailableTitle: "Quiz diario no disponible",
    unavailableDesc: "No se pudo generar el quiz de hoy.",
    retry: "Reintentar",
    finished: "Quiz completado",
    finishedExclaim: "¡Quiz completado!",
    xpGained: "XP ganados",
    daysStreak: "Racha de días",
    timeSpent: "Tiempo dedicado",
    recentBadges: "Insignias recientes",
    backToDashboard: "Volver al panel",
    reviewWithFlashcards: "Repasar con flashcards",
    missingQuestionTitle: "Pregunta faltante",
    missingQuestionDesc: "Ocurrió un error al cargar la pregunta.",
    reload: "Recargar",
    question: "Pregunta",
    of: "/",
    explanation: "Explicación",
    source: "Fuente",
    elapsed: "Tiempo transcurrido",
    validate: "Validar",
    next: "Siguiente",
    finish: "Finalizar",
    today: "Hoy",
    difficulty: {
      easy: "fácil",
      medium: "medio",
      hard: "difícil"
    },
    widget: {
      currentStreak: "Racha actual",
      thisWeek: "Esta semana",
      xpThisWeek: "XP esta semana:",
      startToday: "Comenzar el quiz de hoy",
      completedToday: "Quiz de hoy completado ✓",
      viewResults: "Ver resultados"
    },
    weeklyChallenge: {
      title: "Desafío semanal",
      progress: "Progreso",
      done: "¡Desafío completado!"
    },
    toasts: {
      loadError: "No se pudo cargar el quiz diario",
      finishSuccess: (xp:number) => `¡Quiz completado! +${xp} XP`,
      saveError: "Error al guardar",
      offlineMode: "Quiz generado en modo sin conexión"
    },
    celebrationSubtitle: "Obtuviste {{percentage}}% en el Quiz diario",
    shareScore: "Compartir mi puntuación",
    successRate: "{{percentage}}% de aciertos"
  }
};
